import { render, staticRenderFns } from "./LaboratoryGuidelines.vue?vue&type=template&id=1ddaf3f0"
import script from "./LaboratoryGuidelines.vue?vue&type=script&lang=js"
export * from "./LaboratoryGuidelines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports